import {BankTransactionType} from '@modifi/enums'
import {
  MATCH_TYPE_PAYMENT_FUNDS_TRANSFER,
  MATCH_TYPE_PAYMENT_REPAYMENT,
  MATCH_TYPE_INVOICE_REPAYMENT,
  MATCH_TYPE_INVOICE_FUNDS_TRANSFER,
  MATCH_TYPE_INVOICE_DD_RETURN,
  MATCH_TYPE_PAYMENT_DD_RETURN,
  MATCH_TYPE_PAYMENT_PASS_THROUGH,
  MATCH_GROUP_PAYMENT,
  MATCH_GROUP_INVOICE,
} from '../match/constants'

export const getMatchType = (matchGroup, sourceEntity) => {
  const {amount, transactionType} = sourceEntity || {}
  if (!amount || !transactionType || !matchGroup) return null
  switch (matchGroup) {
    case MATCH_GROUP_PAYMENT: {
      if (transactionType === BankTransactionType.DIRECT_DEBIT_RETURN) {
        // matching returning direct debit transaction to repayment
        return MATCH_TYPE_PAYMENT_DD_RETURN
      }
      if (amount < 0) {
        // matching transaction to funds transfer
        return MATCH_TYPE_PAYMENT_FUNDS_TRANSFER
      }
      // check if it is a pass through
      if (sourceEntity?.isPassThrough) return MATCH_TYPE_PAYMENT_PASS_THROUGH
      // matching transaction to repayment
      return MATCH_TYPE_PAYMENT_REPAYMENT
    }
    case MATCH_GROUP_INVOICE: {
      if (transactionType === BankTransactionType.DIRECT_DEBIT_RETURN) {
        // matching returning direct debit transaction to invoice repayment
        return MATCH_TYPE_INVOICE_DD_RETURN
      }
      if (amount < 0) {
        // matching transaction to invoice funds transfer
        return MATCH_TYPE_INVOICE_FUNDS_TRANSFER
      }
      // matching transaction to invoice repayment
      return MATCH_TYPE_INVOICE_REPAYMENT
    }
    default:
      return null
  }
}

export const matchTypeToLabel = matchType => {
  switch (matchType) {
    case MATCH_TYPE_PAYMENT_FUNDS_TRANSFER:
      return 'Funds Transfer'
    case MATCH_TYPE_PAYMENT_REPAYMENT:
    case MATCH_TYPE_PAYMENT_PASS_THROUGH:
      return 'Repayment'
    case MATCH_TYPE_INVOICE_FUNDS_TRANSFER:
      return 'Invoice Funds Transfer'
    case MATCH_TYPE_INVOICE_REPAYMENT:
      return 'Invoice Repayment'
    case MATCH_TYPE_PAYMENT_DD_RETURN:
      return 'Direct Debit Return (Repayment)'
    case MATCH_TYPE_INVOICE_DD_RETURN:
      return 'Direct Debit Return (Billing)'
    default:
      return null
  }
}
